(ns common.schema.entities.survey.survey-block
  (:require [common.languages :as languages]
            [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/name-unique-per-tenant :survey-block/label
                               "Label"
                               :entity.type/survey-block
                               {:authentication    su/access-user-sug
                                :system-required?  true
                                :system-semantics
                                su/user-provided-system-required-field-semantics})
    (su/text-edn-field :survey-block/config
                       "Configuration"
                       {:default-field-visibility :in-use-disabled
                        :authorization            su/access-user-sug})
    (su/keyword-multi-field :survey-block/languages
                            "Languages"
                            languages/options
                            {:default-field-visibility :in-use-disabled
                             :authorization            su/access-user-sug
                             :mandatory-config         :mandatory/always
                             :system-required?         true
                             :system-semantics
                             su/user-provided-system-required-field-semantics})
    (su/option-field-multi :survey-block/categories
                           "Categories"
                           {:default-field-visibility :in-use-disabled
                            :authorization            su/access-user-user}))))
